import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const LoaderSvg = ()=>{
    return /*#__PURE__*/ _jsx("svg", {
        width: "100px",
        height: "100px",
        viewBox: "0 0 100 12",
        version: "1.1",
        children: /*#__PURE__*/ _jsx("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            className: "nano",
            children: /*#__PURE__*/ _jsx("g", {
                id: "Artboard",
                transform: "translate(0.000000, -77.000000)",
                fill: "#000000",
                fillRule: "nonzero",
                children: /*#__PURE__*/ _jsxs("g", {
                    id: "book1",
                    transform: "translate(0.000000, 77.000000)",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M41.5699929,4 L44.0358739,4 L44.0358739,8.22535363 L44.0327426,8.31316908 C44.0283181,8.44277096 44.0609384,8.67448069 44.1540696,8.86974331 C44.300435,9.17661881 44.5618588,9.34274217 45.212757,9.34274217 L50.8376511,9.34274217 L50.8376511,11.8086232 L45.212757,11.8086232 C43.6082109,11.8086232 42.4826414,11.0933731 41.9283829,9.93129299 C41.6353539,9.31691699 41.5503897,8.71254082 41.5697629,8.20117735 C41.5698164,8.19997263 41.569893,6.79958018 41.5699929,4 Z M99.0196078,4 C99.5610635,4 100,4.43893652 100,4.98039216 C100,5.52184779 99.5610635,5.96078431 99.0196078,5.96078431 L58.2325197,5.96078431 C58.2325835,7.45350005 58.2326349,8.20029773 58.232674,8.20117735 C58.2520471,8.71254082 58.1670829,9.31691699 57.874054,9.93129299 C57.3197955,11.0933731 56.1942259,11.8086232 54.5896798,11.8086232 L48.9647858,11.8086232 L48.9647858,9.34274217 L54.5896798,9.34274217 C55.240578,9.34274217 55.5020018,9.17661881 55.6483673,8.86974331 C55.7414985,8.67448069 55.7741187,8.44277096 55.7696942,8.31316908 L55.7665629,8.22535363 L55.7665629,4 L58.2324439,4 L99.0196078,4 Z M0.980392157,5.96078431 C0.43893652,5.96078431 0,5.52184779 0,4.98039216 C0,4.43893652 0.43893652,4 0.980392157,4 L44.1176471,4 L44.1176471,5.96078431 L0.980392157,5.96078431 Z",
                            id: "cover"
                        }),
                        /*#__PURE__*/ _jsxs("g", {
                            id: "pages",
                            transform: "translate(2.000000, 0.000000)",
                            fill: "#ED008C",
                            children: [
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: ".2s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: ".4s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: ".6s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: ".8s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: "1s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: "1.2s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: "1.4s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: "1.6s",
                                        repeatCount: "indefinite"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M1.5,2.5 C0.94771525,2.5 0.5, 2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525, 0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5, 0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                    id: "page",
                                    children: /*#__PURE__*/ _jsx("animateTransform", {
                                        attributeName: "transform",
                                        attributeType: "XML",
                                        type: "rotate",
                                        from: "0 45 3",
                                        to: "180 48 1.5",
                                        dur: "1.2s",
                                        begin: "1.8s",
                                        repeatCount: "indefinite"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("g", {
                            id: "pages-copy",
                            transform: "translate(55.000000, 0.000000)",
                            fill: "#ED008C",
                            children: /*#__PURE__*/ _jsx("path", {
                                d: "M1.5,2.5 C0.94771525,2.5 0.5,2.05228475 0.5,1.5 C0.5,0.94771525 0.94771525,0.5 1.5,0.5 L41.5,0.5 C42.0522847,0.5 42.5,0.94771525 42.5,1.5 C42.5,2.05228475 42.0522847,2.5 41.5,2.5 L1.5,2.5 Z",
                                id: "page-other-side"
                            })
                        })
                    ]
                })
            })
        })
    });
};
export const Loader = ()=>/*#__PURE__*/ _jsx("div", {
        className: "container--lg align--center",
        children: /*#__PURE__*/ _jsx("div", {
            className: "loader",
            children: /*#__PURE__*/ _jsx(LoaderSvg, {})
        })
    });
{}